var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"modal-body text-center\"><message-icon message=\"{{::title || 'Loading...'}}\" type=\"info\" icon=\"spinner\" spin=\"true\"></message-icon><p ng-bind-html=\"::message\"></p></div>";
var id1="busy.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;